import React from 'react';
import {Navigate, Route, Routes} from 'react-router';
import {ErrorUnstyled} from '@igp/shared/components/error';
import {withTraceErrorBoundary} from '@igp/shared/otel';

import {routes} from '@config';
import {
    AgentLevelReportDaily,
    AgentLevelReportV2Weekly,
    Agents,
    BoUsers,
    DebtResponsibleMasterAgents,
    DebtTransferLogs,
    DepositActivityOverview,
    Dev,
    GameRevenueOverview,
    KeycloakLogs,
    NegativeCarryoverReport,
    PayoutReport,
    PlayerDetails,
    PlayerEcologyWeekly,
    PlayerLevelReportAll,
    PlayerLevelReportBasic,
    PlayerLevelReportCasino,
    PlayerLevelReportGlobalSpins,
    PlayerLevelReportPlayerActivity,
    PlayerLevelReportPlayerEcology,
    PlayerLevelReportPoker,
    PlayerLevelReportPokerMtt,
    PlayerLevelReportPokerNhleSd,
    PlayerLevelReportPokerPlo,
    PlayerLevelReportShare,
    PlayerLevelReportSports,
    PlayerPage,
    ReferralLinkConfigPage,
    RepaymentLogs,
    RevenueShareHistory,
    TransactionHistory,
    UserActivityOverview,
} from '@pages';

export function Router() {
    return (
        <Routes>
            <Route path={routes.home} element={<Navigate to={routes.transactionHistory} replace />} />
            <Route path={routes.transactionHistory} element={<TransactionHistory />} />
            <Route path={routes.revenueShareHistory} element={<RevenueShareHistory />} />
            <Route path={routes.players} element={<PlayerPage />} />
            <Route path={routes.playerDetails} element={<PlayerDetails />} />
            <Route path={routes.agents} element={<Agents />} />
            <Route path={routes.agentDetails} element={<PlayerDetails />} />
            <Route path={routes.agentLevelReportWeekly} element={<AgentLevelReportV2Weekly />} />
            <Route path={routes.playerLevelReport} element={<Navigate to={routes.playerLevelReportShare} replace />} />
            <Route path={routes.playerLevelReportShare} element={<PlayerLevelReportShare />} />
            <Route path={routes.playerLevelReportPoker} element={<PlayerLevelReportPoker />} />
            <Route path={routes.playerLevelReportPokerNhleSd} element={<PlayerLevelReportPokerNhleSd />} />
            <Route path={routes.playerLevelReportPokerMtt} element={<PlayerLevelReportPokerMtt />} />
            <Route path={routes.playerLevelReportPokerPlo} element={<PlayerLevelReportPokerPlo />} />
            <Route path={routes.playerLevelReportCasino} element={<PlayerLevelReportCasino />} />
            <Route path={routes.playerLevelReportGlobalSpins} element={<PlayerLevelReportGlobalSpins />} />
            <Route path={routes.playerLevelReportSports} element={<PlayerLevelReportSports />} />
            <Route path={routes.playerLevelReportBasic} element={<PlayerLevelReportBasic />} />
            <Route path={routes.playerLevelReportPlayerActivity} element={<PlayerLevelReportPlayerActivity />} />
            <Route path={routes.playerLevelReportPlayerEcology} element={<PlayerLevelReportPlayerEcology />} />
            <Route path={routes.playerLevelReportAll} element={<PlayerLevelReportAll />} />
            <Route path={routes.negativeCarryoverReport} element={<NegativeCarryoverReport />} />
            <Route path={routes.payoutReport} element={<PayoutReport />} />
            <Route path={routes.agentLevelReportDaily} element={<AgentLevelReportDaily />} />
            <Route path={routes.countryLevelPartnerReportGameRevenue} element={<GameRevenueOverview />} />
            <Route path={routes.countryLevelPartnerReportUserActivity} element={<UserActivityOverview />} />
            <Route path={routes.countryLevelPartnerReportDepositActivity} element={<DepositActivityOverview />} />
            <Route path={routes.debtTransferLogs} element={<DebtTransferLogs />} />
            <Route path={routes.debtResponsibleMasterAgents} element={<DebtResponsibleMasterAgents />} />
            <Route path={routes.repaymentLogs} element={<RepaymentLogs />} />
            <Route path={routes.keycloakLogs} element={<KeycloakLogs />} />
            <Route path={routes.userManagement} element={<BoUsers />} />
            <Route path={routes.playerEcologyWeekly} element={<PlayerEcologyWeekly />} />
            <Route path={routes.referralLinkConfig} element={<ReferralLinkConfigPage />} />
            <Route path={'/dev'} element={<Dev />} />
        </Routes>
    );
}

export default withTraceErrorBoundary(Router, ErrorUnstyled);
